import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';

import { Button, ButtonType } from '../../components';
import { useDependencies } from '../../dependencies';

export const StripeSecondaryVerification = observer((): JSX.Element => {
  const { stores, services: { tracker } } = useDependencies();
  const { t } = useTranslation();
  const { verification } = stores;

  const getHeader = (): string => {
    if (verification.canFacebookVerify()) {
      return t('identityCheck.stripeVerification.secondaryOption.header');
    }

    return '';
  }

  const getDescription = (): string => {
    if (verification.canFacebookVerify()) {
      return t('identityCheck.stripeVerification.secondaryOption.description');
    }

    return t('identityCheck.stripeVerification.inProgressRequiresNoInput.description2');
  }

  // Mirrors Angular verification-service.js:224 — fires when a user starts
  // a fresh Stripe identity verification flow.
  const startIdentityCheck = (): void => {
    tracker.track('verification-modal', { action: 'stripe-verification-started' });
    verification.openStripe('start');
  };

  return (
    <div className='flex justify-center mb-4 border-2 p-2 rounded-2xl md:w-[250px] md:h-[260px]'>
      <div className='mt-3'>
        <div className='font-bold text-xl mb-2'>{getHeader()}</div>
        <div className='mb-2'>
          {getDescription()}
        </div>
        <div className='text-xs mb-4'>{t('identityCheck.allowPopups')}</div>
        <div className='text-center'>
          <Button
            buttonType={ButtonType.primary}
            className='mb-4'
            disabled={stores.verification.loadingStripe}
            onClick={startIdentityCheck}>
            {t('identityCheck.start')}
          </Button>
        </div>
      </div>
    </div>
  );
});
